export default __webpack_public_path__ + "src/assets/uni-logo.2b8096aa9658855c59a518600034f335.png";